import React from "react";
import styled from "styled-components";
import NetworkPageIframe from "@components/NetworkPageIframe";

const Container = styled.div`
	margin: 24px 0;
`;

const NetworkCoverageInfo: React.FC = () => {
	return (
		<Container>
			<NetworkPageIframe />
		</Container>
	);
};

export default NetworkCoverageInfo;

